import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import {
  Plus,
  MapPin,
  Edit,
  Trash2,
  Loader2,
  XCircle,
  CheckCircle,
  Search,
  ChevronLeft,
  ChevronRight,
  Save,
  MinusCircle,
} from "lucide-react";

// Backend API'nızın çalıştığı adres. Python'u çalıştırdığınızda bu adres olacaktır.
const API_BASE_URL = process.env.REACT_APP_API_URL;

const ITEMS_PER_PAGE = 10;

// ----- BİLEŞENLER (COMPONENTS) -----

const MessageModal = ({ message, type, onClose }) => {
    // Bu bileşende değişiklik yok, olduğu gibi harika çalışıyor.
    const icon = type === "success" ? <CheckCircle className="h-16 w-16 text-green-500" /> : <XCircle className="h-16 w-16 text-red-500" />;
    const title = type === "success" ? "Başarılı!" : "Hata!";
    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-50">
            <div className="bg-gray-800 rounded-xl p-8 max-w-sm w-full shadow-2xl text-center relative">
                {icon}
                <h2 className="text-xl font-bold text-gray-50 mt-4 mb-2">{title}</h2>
                <p className="text-gray-300">{message}</p>
                <button
                    onClick={onClose}
                    className={`mt-6 px-6 py-2 text-white rounded-lg transition-colors ${type === "success" ? 'bg-green-600 hover:bg-green-500' : 'bg-red-600 hover:bg-red-500'}`}
                >
                    Kapat
                </button>
            </div>
        </div>
    );
};

const PlaceFormModal = ({ onClose, onSubmit, formData, setFormData, isEditing }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // Latitude ve Longitude için number'a çeviriyoruz
        const isCoord = name === 'latitude' || name === 'longitude';
        setFormData({ ...formData, [name]: isCoord ? parseFloat(value) || 0 : value });
    };
    
    // Açıklama bölümlerindeki değişiklikleri yönetir
    const handleAçıklamaChange = (index, event) => {
        const yeniAçıklamalar = [...formData.aciklama_bolumleri];
        yeniAçıklamalar[index][event.target.name] = event.target.value;
        setFormData({ ...formData, aciklama_bolumleri: yeniAçıklamalar });
    };

    // Yeni bir açıklama bölümü ekler
    const handleAçıklamaEkle = () => {
        setFormData({
            ...formData,
            aciklama_bolumleri: [...formData.aciklama_bolumleri, { baslik: "", icerik: "" }],
        });
    };

    // Bir açıklama bölümünü siler
    const handleAçıklamaSil = (index) => {
        const yeniAçıklamalar = formData.aciklama_bolumleri.filter((_, i) => i !== index);
        setFormData({ ...formData, aciklama_bolumleri: yeniAçıklamalar });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        await onSubmit(e);
        setIsSubmitting(false);
    };

    return (
        <div id="modalBackdrop" className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm z-50 p-4" onClick={(e) => e.target.id === "modalBackdrop" && onClose()}>
            <form onSubmit={handleSubmit} className="bg-gray-800 rounded-2xl shadow-2xl p-8 w-full max-w-2xl border border-gray-700 text-gray-50 max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-6">
                    <h3 className="text-2xl font-bold">{isEditing ? "Mekânı Düzenle" : "Yeni Mekân Ekle"}</h3>
                    <button type="button" onClick={onClose} className="text-gray-400 hover:text-white transition-colors" aria-label="Kapat"><XCircle className="h-6 w-6" /></button>
                </div>

                <div className="space-y-4">
                    {/* Temel Bilgiler */}
                    <input type="text" name="ad" value={formData.ad} onChange={handleInputChange} placeholder="Mekân Adı" className="block w-full px-4 py-3 bg-gray-700 rounded-lg border border-gray-600 focus:ring-2 focus:ring-blue-400" required />
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <input type="text" name="il" value={formData.il} onChange={handleInputChange} placeholder="Şehir" className="block w-full px-4 py-3 bg-gray-700 rounded-lg border border-gray-600 focus:ring-2 focus:ring-blue-400" required />
                        <input type="text" name="ilce" value={formData.ilce} onChange={handleInputChange} placeholder="İlçe" className="block w-full px-4 py-3 bg-gray-700 rounded-lg border border-gray-600 focus:ring-2 focus:ring-blue-400" required />
                        <input type="number" step="any" name="latitude" value={formData.latitude} onChange={handleInputChange} placeholder="Enlem (Latitude)" className="block w-full px-4 py-3 bg-gray-700 rounded-lg border border-gray-600 focus:ring-2 focus:ring-blue-400" required />
                        <input type="number" step="any" name="longitude" value={formData.longitude} onChange={handleInputChange} placeholder="Boylam (Longitude)" className="block w-full px-4 py-3 bg-gray-700 rounded-lg border border-gray-600 focus:ring-2 focus:ring-blue-400" required />
                    </div>
                     <input type="text" name="gorsel" value={formData.gorsel} onChange={handleInputChange} placeholder="Görsel URL (örn: ./ankara/Anıtkabir/...) " className="block w-full px-4 py-3 bg-gray-700 rounded-lg border border-gray-600 focus:ring-2 focus:ring-blue-400" required />

                    {/* Açıklama Bölümleri */}
                    <div className="pt-4 border-t border-gray-700">
                         <h4 className="text-lg font-semibold mb-2 text-gray-300">Açıklama Bölümleri</h4>
                         {formData.aciklama_bolumleri.map((bolum, index) => (
                             <div key={index} className="p-4 mb-3 bg-gray-700/50 rounded-lg border border-gray-600 relative">
                                <div className="space-y-3">
                                    <input
                                        type="text"
                                        name="baslik"
                                        value={bolum.baslik}
                                        onChange={(e) => handleAçıklamaChange(index, e)}
                                        placeholder={`Bölüm ${index + 1} Başlığı`}
                                        className="block w-full px-3 py-2 bg-gray-600 rounded-md border border-gray-500 focus:ring-1 focus:ring-blue-400"
                                    />
                                    <textarea
                                        name="icerik"
                                        value={bolum.icerik}
                                        onChange={(e) => handleAçıklamaChange(index, e)}
                                        placeholder={`Bölüm ${index + 1} İçeriği`}
                                        rows="3"
                                        className="block w-full px-3 py-2 bg-gray-600 rounded-md border border-gray-500 focus:ring-1 focus:ring-blue-400 resize-y"
                                    ></textarea>
                                </div>
                                {formData.aciklama_bolumleri.length > 1 && (
                                     <button type="button" onClick={() => handleAçıklamaSil(index)} className="absolute top-2 right-2 text-red-400 hover:text-red-300"><MinusCircle className="h-5 w-5"/></button>
                                )}
                             </div>
                         ))}
                         <button type="button" onClick={handleAçıklamaEkle} className="mt-2 flex items-center gap-2 text-sm text-green-400 hover:text-green-300 font-semibold"><Plus className="h-4 w-4"/> Yeni Bölüm Ekle</button>
                    </div>
                </div>

                <div className="flex justify-end gap-4 mt-8">
                    <button type="button" onClick={onClose} className="px-6 py-3 rounded-lg border border-gray-600 text-gray-300 hover:bg-gray-700">İptal</button>
                    <button type="submit" disabled={isSubmitting} className={`px-6 py-3 rounded-lg font-semibold flex items-center gap-2 ${isSubmitting ? "bg-blue-400 cursor-not-allowed" : "bg-blue-600 text-white hover:bg-blue-700"}`}>
                        {isSubmitting ? <><Loader2 className="h-5 w-5 animate-spin" /> İşleniyor...</> : <>{isEditing ? <Save className="h-5 w-5" /> : <Plus className="h-5 w-5" />} {isEditing ? "Kaydet" : "Ekle"}</>}
                    </button>
                </div>
            </form>
        </div>
    );
};

const ConfirmDeleteModal = ({ onClose, onConfirm }) => {
    // Bu bileşende değişiklik yok, olduğu gibi harika çalışıyor.
    return (
        <div id="confirmModalBackdrop" className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm z-50 p-4" onClick={(e) => e.target.id === "confirmModalBackdrop" && onClose()}>
            <div className="bg-gray-800 rounded-2xl shadow-2xl p-8 w-full max-w-sm border border-gray-700 text-gray-50 text-center">
                <Trash2 className="h-16 w-16 text-red-500 mx-auto mb-4" />
                <h3 className="text-2xl font-bold mb-4">Silme Onayı</h3>
                <p className="text-gray-300 mb-6">Bu mekânı silmek istediğine emin misin? Bu işlem geri alınamaz.</p>
                <div className="flex justify-center gap-4">
                    <button type="button" onClick={onClose} className="px-6 py-3 rounded-lg border border-gray-600 text-gray-300 hover:bg-gray-700">İptal</button>
                    <button type="button" onClick={onConfirm} className="px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700">Sil</button>
                </div>
            </div>
        </div>
    );
};

// ----- ANA SAYFA BİLEŞENİ (MAIN PAGE COMPONENT) -----

export default function AdminPanel() {
    const [places, setPlaces] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isFormModalOpen, setIsFormModalOpen] = useState(false);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
    const [message, setMessage] = useState({ type: "", text: "" });
    const [placeToManipulate, setPlaceToManipulate] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [isEditing, setIsEditing] = useState(false);

    // JSON veri yapısına uygun başlangıç state'i
    const initialFormState = {
        id: null,
        gorsel: "",
        ad: "",
        il: "",
        ilce: "",
        latitude: 0.0,
        longitude: 0.0,
        aciklama_bolumleri: [{ baslik: "", icerik: "" }],
    };
    const [form, setForm] = useState(initialFormState);

    const fetchPlaces = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${API_BASE_URL}/api/mekanlar`);
            setPlaces(Array.isArray(res.data) ? res.data : []);
            setError(null);
        } catch (err) {
            setError("Mekânlar yüklenirken hata oluştu.");
            console.error("Fetch hatası:", err);
            setPlaces([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPlaces();
    }, []);

    const filteredData = useMemo(() => {
        return places.filter(place =>
            (place.ad?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
            (place.il?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
            (place.ilce?.toLowerCase() || '').includes(searchTerm.toLowerCase())
        );
    }, [places, searchTerm]);

    const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
    const paginatedData = filteredData.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) setCurrentPage(newPage);
    };

    const resetForm = () => {
        setForm(initialFormState);
        setIsEditing(false);
    };

    const openFormModal = (place = null) => {
        if (place) {
             // Düzenleme için formu doldururken aciklama_bolumleri'nin boş olmamasını garantile
            setForm({
                ...place,
                aciklama_bolumleri: place.aciklama_bolumleri && place.aciklama_bolumleri.length > 0
                    ? place.aciklama_bolumleri
                    : [{ baslik: "", icerik: "" }]
            });
            setIsEditing(true);
        } else {
            resetForm();
        }
        setIsFormModalOpen(true);
    };

    const closeFormModal = () => {
        setIsFormModalOpen(false);
        resetForm();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isEditing) {
                await axios.put(`${API_BASE_URL}/api/mekanlar/${form.id}`, form);
                setMessage({ type: "success", text: "Mekân başarıyla güncellendi!" });
            } else {
                // Yeni eklemede 'id' alanını göndermiyoruz, backend oluşturacak
                const { id, ...newPlaceData } = form;
                await axios.post(`${API_BASE_URL}/api/mekanlar`, newPlaceData);
                setMessage({ type: "success", text: "Mekân başarıyla eklendi!" });
            }
            closeFormModal();
            setIsMessageModalOpen(true);
            fetchPlaces();
        } catch (err) {
            setMessage({ type: "error", text: "İşlem sırasında bir hata oluştu." });
            setIsMessageModalOpen(true);
            console.error("İşlem hatası:", err);
        }
    };

    const openConfirmModal = (place) => {
        setPlaceToManipulate(place);
        setIsConfirmModalOpen(true);
    };

    const closeConfirmModal = () => {
        setIsConfirmModalOpen(false);
        setPlaceToManipulate(null);
    };

    const confirmDelete = async () => {
        try {
            if (placeToManipulate && placeToManipulate.id) {
                await axios.delete(`${API_BASE_URL}/api/mekanlar/${placeToManipulate.id}`);
                setMessage({ type: "success", text: "Mekân başarıyla silindi!" });
                fetchPlaces();
            }
        } catch (err) {
            setMessage({ type: "error", text: "Silme işlemi sırasında bir hata oluştu." });
            console.error("Silme hatası:", err);
        } finally {
            closeConfirmModal();
            setIsMessageModalOpen(true);
        }
    };

    if (loading) return <div className="flex items-center justify-center min-h-screen bg-gray-900"><Loader2 className="h-10 w-10 animate-spin text-blue-500" /></div>;
    if (error) return <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-red-400"><XCircle className="h-16 w-16 mb-4" /><p>{error}</p></div>;

    return (
        <div className="flex-1 p-6 bg-gray-900 text-gray-50 min-h-screen">
            <div className="flex items-center justify-between mb-8">
                <h1 className="text-4xl font-extrabold text-white">Mekân Yönetimi</h1>
                <button onClick={() => openFormModal()} className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 text-white font-semibold rounded-lg shadow-md hover:bg-green-700"><Plus className="h-5 w-5" /> Yeni Mekân Ekle</button>
            </div>

            <div className="mb-8 p-4 bg-gray-800 rounded-2xl border border-gray-700">
                <div className="relative"><Search className="absolute h-5 w-5 text-gray-400 left-3 top-1/2 -translate-y-1/2" /><input type="text" placeholder="Mekân adı, şehir veya ilçe ara..." className="w-full pl-10 pr-4 py-3 bg-gray-700 rounded-lg focus:ring-2 focus:ring-blue-500 border border-gray-600" value={searchTerm} onChange={e => { setSearchTerm(e.target.value); setCurrentPage(1); }}/></div>
            </div>

            <div className="bg-gray-800 rounded-2xl shadow-xl border border-gray-700 overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="min-w-full">
                        <thead className="bg-gray-700/50"><tr className="text-left text-sm font-semibold text-gray-300"><th className="px-6 py-4">#</th><th className="px-6 py-4">Mekân Adı</th><th className="px-6 py-4">Şehir</th><th className="px-6 py-4">İlçe</th><th className="px-6 py-4">İlk Açıklama</th><th className="px-6 py-4 text-right">İşlemler</th></tr></thead>
                        <tbody className="divide-y divide-gray-700">
                            {paginatedData.length === 0 ? (<tr><td colSpan={6} className="text-center py-10 text-gray-500">Kayıtlı mekân bulunamadı.</td></tr>) : (
                                paginatedData.map((place, index) => (
                                    <tr key={place.id} className="hover:bg-gray-700/50">
                                        <td className="px-6 py-4 text-gray-400">{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                                        <td className="px-6 py-4 font-medium text-gray-300">{place.ad}</td>
                                        <td className="px-6 py-4 text-gray-400">{place.il}</td>
                                        <td className="px-6 py-4 text-gray-400">{place.ilce}</td>
                                        <td className="px-6 py-4 text-gray-400 text-sm max-w-xs truncate" title={place.aciklama_bolumleri?.[0]?.icerik}>
                                            {place.aciklama_bolumleri?.[0]?.icerik || "Açıklama yok"}
                                        </td>
                                        <td className="px-6 py-4 text-right space-x-2">
                                            <button onClick={() => openFormModal(place)} className="inline-flex items-center gap-1 bg-blue-600/20 text-blue-400 px-3 py-1 rounded-lg hover:bg-blue-600/30 text-sm"><Edit className="h-4 w-4" /> Düzenle</button>
                                            <button onClick={() => openConfirmModal(place)} className="inline-flex items-center gap-1 bg-red-600/20 text-red-400 px-3 py-1 rounded-lg hover:bg-red-600/30 text-sm"><Trash2 className="h-4 w-4" /> Sil</button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {totalPages > 1 && (
                <div className="flex justify-center items-center space-x-3 mt-8">
                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="px-4 py-2 rounded-lg font-semibold disabled:text-gray-600 disabled:bg-gray-800 disabled:cursor-not-allowed text-white bg-gray-700 hover:bg-gray-600"><ChevronLeft className="h-5 w-5" /></button>
                    <span className="px-4 py-2 rounded-lg bg-gray-700 text-white font-semibold">{currentPage} / {totalPages}</span>
                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="px-4 py-2 rounded-lg font-semibold disabled:text-gray-600 disabled:bg-gray-800 disabled:cursor-not-allowed text-white bg-gray-700 hover:bg-gray-600"><ChevronRight className="h-5 w-5" /></button>
                </div>
            )}

            {isFormModalOpen && <PlaceFormModal onClose={closeFormModal} onSubmit={handleSubmit} formData={form} setFormData={setForm} isEditing={isEditing} />}
            {isConfirmModalOpen && <ConfirmDeleteModal onClose={closeConfirmModal} onConfirm={confirmDelete} />}
            {isMessageModalOpen && <MessageModal message={message.text} type={message.type} onClose={() => setIsMessageModalOpen(false)} />}
        </div>
    );
}
